import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../data/content";
import useReveal from "../shared/useReveal";
import "./ServicesIndex.css";
import "./HomeSections.css";

const FEATURED_SLUGS = ["portfolio-management", "mutual-funds"];

export default function ServicesIndex() {
  const ref = useReveal();
  const featured = SERVICES.filter((s) => FEATURED_SLUGS.includes(s.slug));
  const rest = SERVICES.filter((s) => !FEATURED_SLUGS.includes(s.slug));

  const numFor = (slug) => {
    const i = SERVICES.findIndex((s) => s.slug === slug);
    return String(i + 1).padStart(2, "0");
  };

  return (
    <section className="section alt home-svc-section" id="all-services">
      <div className="container" ref={ref}>
        <div className="home-section-head section-head home-svc-head pm-reveal">
          <span className="kicker">Services We Offer</span>
          <h2>Sixteen services. One accountable partner.</h2>
        </div>

        <div className="home-svc-bento pm-stagger">
          <div className="home-svc-featured">
            {featured.map((svc) => (
              <Link
                key={svc.slug}
                to={svc.href}
                className="home-svc-tile home-svc-tile--featured pm-reveal"
              >
                <span className="no">{numFor(svc.slug)}</span>
                <div>
                  <h3>{svc.title}</h3>
                  <p>{svc.desc}</p>
                </div>
                <ArrowUpRight size={16} className="go-ic" aria-hidden />
              </Link>
            ))}
          </div>

          <div className="home-svc-grid">
            {rest.map((svc) => (
              <Link
                key={svc.slug}
                to={svc.href}
                className="home-svc-tile home-svc-tile--chip pm-reveal"
              >
                <span className="no">{numFor(svc.slug)}</span>
                <span className="title">{svc.title}</span>
                <ArrowUpRight size={14} className="go-ic" aria-hidden />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
